import * as React from 'react'

import * as Bowser from 'bowser'
import * as ReactDOM from 'react-dom/client'

import { t, tc } from '@owl-nest/localize'
import * as logger from '@owl-nest/logger'
import * as messages from '@owl-nest/messages'

import * as plume from '@ulule/owl-kit-components/next'

export function renderCrashToast(context: string, error?: Error, extra?: Record<string, unknown>): void {
  const reason = error ? ` (${error})` : ''
  logger.err(`[${context}] Failed to load and display resource${reason}`, {
    error,
    ...extra,
  })

  const appContainer = document.querySelector('#app-error-container')
  if (appContainer) {
    const root = ReactDOM.createRoot(appContainer)
    root.render(
      <messages.MessagesProvider>
        <messages.ToastDisplayer contexts={['global']} position="top" />
        <ErrorDisplay />
      </messages.MessagesProvider>,
    )
  } else {
    logger.err(`[${context}] Global error container is missing`)
  }
}

function ErrorDisplay(): React.ReactElement<unknown> {
  const messenger = messages.useMessage()
  const bowser = Bowser.getParser(window.navigator.userAgent)
  const traceId = logger.getCurrentScope().getPropagationContext().traceId

  React.useEffect(() => {
    messenger.error({
      context: 'global',
      message: tc(
        "It seems we're having trouble loading this page. Our team has been notified and will look into it as soon as possible." +
          '[br][br]' +
          'If the issue persists, feel free to [contact: contact our support team] while sharing the following information:' +
          '[br][br]' +
          `Browser: %(browserInfo)s` +
          '[br]' +
          `System: %(systemInfo)s` +
          '[br]' +
          `%(errorCodeSnippet)s`,
        {
          browserInfo: `${bowser.getBrowserName()} ${bowser.getBrowserVersion()}`,
          errorCodeSnippet: `${
            traceId
              ? `${t('Error code: %(errorId)s', {
                  errorId: traceId,
                })} `
              : ''
          }`,
          br: <br />,
          contact: <plume.Link href="mailto:support@ulule.com" />,
          systemInfo: `${bowser.getPlatform().vendor || ''} ${bowser.getOSName()} ${bowser.getOSVersion() || ''} ${
            bowser.getOS().versionName || ''
          } [${bowser.getPlatformType()}]`,
        },
      ),
      type: 'toast',
    })
  }, [])

  return <></>
}
